import { DashboardColumn, DashboardInstallationData } from '@vi-iot/client';

import { GenericStoreStatus } from '../installation-details';
import {
  DashboardFilter,
  DashboardListFilterButtonData,
  QuickViewDashboardData,
} from './kanban-board.model';
import { StatusValue } from '../app.state.models';

export interface KanbanBoardState {
  columnDialogVisible: boolean;
  columnDialogData: DashboardInstallationColumn;
  columns: DashboardInstallationColumn[];
  fetchingDashboardStatus: GenericStoreStatus;
  predefinedFilters: DashboardFilter[];
  filters: DashboardFilter[];
  selectedFilters: DashboardFilter[];
  quickViewDashboardData: QuickViewDashboardData;
  forcedStoreUpdateStatus: GenericStoreStatus;
  recoverDataInCaseDeleteError: DashboardInstallationColumn;
  columnCreationFlow: ColumnCreationFlow;
  idOfOriginalColumnDuringColumnCreationAndMoveProcess: number;
  installationList: InstallationListDashboardState;
}

export interface DashboardInstallationColumn extends DashboardColumn {
  loading: boolean;
  canFetch: boolean;
  isTemporary?: boolean;
  inputShowed?: boolean;
  // Custom flag; backend returns filtered installationId and performing drag&drop with filter applied cleared he whole columne
  allInstallationIds: number[];
}

export interface SingleDashboardColumnInstallationsUpdate {
  id: number;
  version: string;
  installations: DashboardInstallationData[];
}

export interface KanbanColumnPrimaryData {
  id: number;
  version: string;
  name: string;
  index: number;
}

export enum ColumnCreationFlow {
  Add,
  AddAndCopy,
  AddAndMove,
}

export interface InstallationListDashboardState extends StatusValue<DashboardInstallationData[]> {
  canFetch: boolean; // flag used when fetching with filters applied
  buttonFilterData: DashboardListFilterButtonData[];
  cursor: string;
}
